module.exports = __webpack_public_path__ + "static/media/brand-refresh-ClockCounterClockwise.2edd160c.svg";